import { CenteredRowContainer } from 'components/layout/centered-row-container';
import { useServiceModeNotification } from 'components/top-service-mode-notification/hooks/use-service-mode-notification';
import { CustomEventNames, EventTypes, logEvent } from 'state/amplitude';

import { MenuReorderCardContainer } from './menu-reorder-card/menu-reorder-card-container';

export const MenuReorderWidget = () => {
  const topServiceModeNotificationDetails = useServiceModeNotification();

  // if we are showing, the service mode notification means that
  // the user has an order in place, so we should hide this card
  if (topServiceModeNotificationDetails) {
    return null;
  }

  return (
    <CenteredRowContainer>
      <MenuReorderCardContainer
        openDetailEventMessage={CustomEventNames.LAST_ORDER_DETAILS}
        logViewEvent={() => {
          logEvent(CustomEventNames.LAST_ORDER_HOME_VIEW, EventTypes.Other);
        }}
        isAvailable={() => true}
        logReorderEvent={() => logEvent(CustomEventNames.LAST_ORDER_REORDER, EventTypes.Other)}
        logOpenDetailEvent={() => logEvent(CustomEventNames.LAST_ORDER_DETAILS, EventTypes.Other)}
      />
    </CenteredRowContainer>
  );
};
